import { Component } from '@angular/core';

@Component({
  selector: 'app-turbo-industries-pvt-ltd',
  templateUrl: './turbo-industries-pvt-ltd.component.html',
  styleUrls: ['./turbo-industries-pvt-ltd.component.scss']
})
export class TurboIndustriesPvtLtdComponent {

}
